import * as R from 'ramda'
import { useRef, useState } from 'react'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
// Material
import { useHistoryCustomBack, usePanelHistoryTop } from 'weblite-router'
// components
import { getClientUser, updateClientUser } from '$logic/client-user'
import { closeEditAccount } from '$logic/router'
import {
  showConfirmUpdatesOnProfile,
  showDiscardChangesConfirmModal,
} from '$comp/modals/confirmation-dialog'
import { areEqualStr } from '$func/text'
import { showSaveChangesLoadingModal } from '$comp/modals/loading-modal'
import { PageWithAppBar } from '$common/page-with-app-bar'
import { AppBarBackTitleConfirm } from '$common/app-bar/app-bar-back-title-confirm'
import { SettingsSection } from '$common/settings-section'
import { t } from '$i18n'
import { EditAccountImageApiType } from '$comp/_app/components/leftPanel/components/edit-account/edit-account-profile-box'
import { createIdentifiedSession as createAnalyticsIdentifiedSession } from '$logic/analytics'
import {
  EditAccountCommonBoxApiType,
  EditAccountCommonInfo,
} from './edit-account-common-info'

export function EditAccount() {
  const commonRef = useRef<EditAccountCommonBoxApiType>(null)
  const imageRef = useRef<EditAccountImageApiType>(null)
  const [firstNameIsEmpty, setFirstNameIsEmpty] = useState<boolean>(false)

  const getChangedFields = () => {
    const user = getClientUser()

    const userChangesField = {
      ...(!areEqualStr(imageRef.current?.get(), user.image || '') && {
        image: imageRef.current?.get(),
      }),
      ...(!areEqualStr(commonRef.current?.getFirstname(), user.firstname) && {
        firstname: commonRef.current?.getFirstname(), // TODO : check these
      }),
      ...(!areEqualStr(
        commonRef.current?.getLastname(),
        user.lastname || '',
      ) && {
        lastname: commonRef.current?.getLastname(),
      }),
    }

    return {
      userChangesField,
    }
  }

  const onSave = async () => {
    const { userChangesField } = getChangedFields()

    if ('firstname' in userChangesField && !userChangesField.firstname) {
      setFirstNameIsEmpty(true)
      return
    }
    // TODO: Verify props

    const requests: (() => Promise<void>)[] = []

    if (!R.isEmpty(userChangesField))
      requests.push(() => updateClientUser(userChangesField))

    if (requests.length) {
      await showConfirmUpdatesOnProfile(async () => {
        showSaveChangesLoadingModal()
        await Promise.all(requests.map(req => req()))
        await closeCurrentModal()
        await closeEditAccount()
        await createAnalyticsIdentifiedSession()
        analite('PROFILE_EDIT_INFO')
      })
    } else await closeEditAccount()
  }

  const onBack = () => {
    const { userChangesField } = getChangedFields()
    if (R.isEmpty(userChangesField)) closeEditAccount()
    else showDiscardChangesConfirmModal(closeEditAccount, onSave)
  }

  // TODO: after pushing back button, page temporary data should be reset.
  useHistoryCustomBack(onBack, [onBack])

  const panel = usePanelHistoryTop()
  return (
    <PageWithAppBar
      key={panel?.location}
      appBar={
        <AppBarBackTitleConfirm
          onBack={onBack}
          onConfirm={onSave}
          title={t('myAccountEdit.title')}
        />
      }
    >
      <SettingsSection sx={{ padding: '0 16px 32px' }}>
        <EditAccountCommonInfo
          ref={imageRef}
          forwardedRef={commonRef}
          firstNameIsEmpty={firstNameIsEmpty}
        />
      </SettingsSection>
    </PageWithAppBar>
  )
}
